import { useAuthStore } from './stores/auth'

export default {
  install: (app) => {
    app.config.globalProperties.$can = function (permissions) {
      const authStore = useAuthStore()
      if (!authStore.authUser) {
        return false
      }

      if (!Array.isArray(permissions)) {
        permissions = [permissions]
      }

      for (let i = 0; i < permissions.length; i++) {
        if (!authStore.authUser.all_permissions_list.includes(permissions[i])) {
          return false
        }
      }

      return true
    }
    app.config.globalProperties.$cannot = function (permissions) {
      return !app.config.globalProperties.$can(permissions)
    }
  }
}
